module.exports = __webpack_public_path__ + "static/media/video-bg.a11e4fb9.jpg";